import {DICTIONARIES} from './dictionariesActionsTypes';

export function setDictionariesEdit(data) {
  return {
    type: DICTIONARIES.SET_MODAL_POPUP,
    payload: data
  };
}
export function closeDictionariesEdit() {
  return {
    type: DICTIONARIES.CLOSE_MODAL_POPUP,
    payload: {}
  };
}
export function resetAllDictionariesEdit() {
  return {
    type: DICTIONARIES.RESET_ALL,
    payload: {}
  };
}
